import { toBrazilianDate } from '../../../../helpers/utils/utils';

/**
 * Mapper puro DTO real (`buscarDocumentosClientePorIdClienteService`) →
 * shape de UI (AW2-1136 Etapa 5) — porta simplificada de
 * `documentosClienteController.makeDocumentos`/`makeContentResponseDocumentos`
 * reais: mesmos campos e mesma formatação de data (`toBrazilianDate`), sem a
 * truncagem `textOverflow` (o protótipo não reproduz a largura fixa de
 * coluna da tabela real — mostrar o texto completo é mais fiel ao dado, não
 * menos, e não altera nenhum comportamento de negócio).
 */
function mapearDocumento(documento) {
  const nomeDocumento = documento?.nomeDocumento
    ? `${documento.nomeDocumento}.${documento.extensao}`
    : '';

  return {
    idClienteDocumento: documento?.idClienteDocumento ?? -1,
    tipo: documento?.tipo ?? '',
    descricao: documento?.descricao ?? '',
    nomeDocumento,
    isDocumentoOriginal: documento?.serDocumentoOriginal ?? false,
    dataArquivamento: toBrazilianDate(documento?.dataArquivamento) || '',
    nomeUsuario: documento?.nomeUsuario ?? '',
    extensao: documento?.extensao ?? '',
  };
}

export function mapearDocumentos(response) {
  return {
    content: (response?.content || []).map(mapearDocumento),
    size: response?.size ?? 0,
    page: response?.number ?? 0,
    totalElements: response?.totalElements ?? 0,
  };
}
